import { _apiV2_get } from "@/app/api2"
import { mainLogger as log } from "@/app/logger"
import { List, MetaTerms, Term } from "@/app/types"

function _mapTermList(l: any[]): List<Term> {
  return l?.map((x) => new Term(x))
}
export async function apiv2_getMetaTerms(): Promise<MetaTerms> {
  return _apiV2_get("/meta/terms", {
    key: "getMetaTerms()",
    cacheLS: true,
  }).then((json) => {
    const metaTerms = new MetaTerms()

    log.debug("apiv2, meta terms json:", json)

    metaTerms.periodic = {
      daily: _mapTermList(json.periodic.daily),
      monthly: _mapTermList(json.periodic.monthly),
      quarterly: _mapTermList(json.periodic.quarterly),
      annual: _mapTermList(json.periodic.annual),
      names: json.periodic.names,
    }

    metaTerms.ranking = {
      daily: _mapTermList(json.ranking.daily),
      monthly: _mapTermList(json.ranking.monthly),
      quarterly: _mapTermList(json.ranking.quarterly),
      annual: _mapTermList(json.ranking.annual),
      names: json.ranking.names,
    }

    log.debug("apiv2, loaded meta terms:", metaTerms.toString())

    return metaTerms
  })
}
